import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={25.701}
    height={21.542}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 69223 58021"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#231f20}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974225760640">
        <path
          d="M54844 53818c-58 715-28 2064 772 3069 592 743 1471 1134 2547 1134 1073 0 1953-395 2544-1134 800-1005 829-2354 776-3069h-6639zM68802 50260l-7399-8494c-308-352-757-556-1231-556h-976v-2573c0-2077-1691-3767-3768-3767H44050v-3273c0-2078-1690-3768-3768-3768h-4955V5163h5609V0H28283v5163h5609v22666h-4955c-2078 0-3768 1690-3768 3768v3273H14111c-2078 0-3767 1690-3767 3767v2573H9048c-474 0-923 204-1231 556L418 50260c-376 433-513 1058-351 1625 201 728 840 1217 1582 1217h18825c743 0 1377-489 1581-1217 158-571 26-1191-354-1625l-7399-8494c-309-352-757-556-1231-556h-1292v-2573c0-1287 1044-2332 2332-2332h19781v4906h-1294c-471 0-919 204-1228 556l-7403 8493c-376 434-513 1058-351 1625 205 729 840 1217 1582 1217h18824c743 0 1378-488 1582-1213 162-571 26-1195-351-1629l-7403-8493c-308-352-753-556-1227-556h-1295v-4906h20101c1284 0 2332 1045 2332 2332v2573h-1611c-474 0-922 204-1230 556l-7400 8494c-377 433-513 1054-351 1628 205 725 840 1214 1583 1214h18823c743 0 1379-489 1583-1217 157-571 25-1191-356-1625zM26606 34870v-3272c0-1289 1047-2332 2332-2332h4954v5604h-7286zm8722-5604h4955c1284 0 2333 1043 2333 2332v3272h-7288v-5604zM31295 53818c-54 715-25 2068 771 3069 589 739 1471 1134 2544 1134 1076 0 1956-395 2548-1134 796-998 826-2351 772-3069h-6635zM7743 53818c-58 715-30 2064 770 3069 593 743 1472 1134 2548 1134 1073 0 1953-395 2544-1134 797-998 826-2351 772-3069H7743z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
